"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFredflixData = exports.FredflixProvider = exports.FredflixContext = void 0;
var react_1 = __importStar(require("react"));
var useProfile_1 = __importDefault(require("./useProfile"));
var Fredflix_1 = require("stremio/services/Fredflix");
exports.FredflixContext = (0, react_1.createContext)({
    data: null,
    loading: true,
    isUserActive: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setData: function () { }
});
var FredflixProvider = function (_a) {
    var _b;
    var children = _a.children;
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    var _d = (0, react_1.useState)(true), isUserActive = _d[0], setIsUserActive = _d[1];
    var _e = (0, react_1.useState)(null), data = _e[0], setData = _e[1];
    var profile = (0, useProfile_1.default)();
    (0, react_1.useEffect)(function () {
        var markLoginToFredflixFlow = function (email) { return __awaiter(void 0, void 0, void 0, function () {
            var now, lastLoggedIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        now = new Date().getTime();
                        lastLoggedIn = localStorage.getItem('fredflixLastLoggedIn');
                        if (!(!lastLoggedIn || now - Number(lastLoggedIn) > 3600000)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, Fredflix_1.RunFredflixFlow)(email, 'Login', {})];
                    case 1:
                        _a.sent();
                        localStorage.setItem('fredflixLastLoggedIn', now.toString());
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var getUserData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, responseData, _i, responseData_1, d, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch('https://wm.frederon.com/api/r/fredflix_get_user')];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("HTTP error! status: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseData = _b.sent();
                        if (!responseData) {
                            throw new Error('fredflix user data is not array');
                        }
                        _i = 0, responseData_1 = responseData;
                        _b.label = 3;
                    case 3:
                        if (!(_i < responseData_1.length)) return [3 /*break*/, 6];
                        d = responseData_1[_i];
                        if (!(((_a = profile.auth) === null || _a === void 0 ? void 0 : _a.user.email) === d.Email)) return [3 /*break*/, 5];
                        return [4 /*yield*/, markLoginToFredflixFlow(d.Email)];
                    case 4:
                        _b.sent();
                        setData(d);
                        if (d.Status !== 'Active') {
                            setIsUserActive(false);
                        }
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _b.sent();
                        console.error('Error fetching user data:', error_1);
                        return [3 /*break*/, 8];
                    case 8:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (profile && profile.auth && profile.auth.user && profile.auth.user.email && profile.auth.user.email !== (data === null || data === void 0 ? void 0 : data.Email)) {
            getUserData();
        }
    }, [(_b = profile.auth) === null || _b === void 0 ? void 0 : _b.user.email]);
    return (react_1.default.createElement(exports.FredflixContext.Provider, { value: { data: data, loading: loading, setData: setData, isUserActive: isUserActive } }, children));
};
exports.FredflixProvider = FredflixProvider;
var useFredflixData = function () { return (0, react_1.useContext)(exports.FredflixContext); };
exports.useFredflixData = useFredflixData;
